import { render, staticRenderFns } from "./CampagnaContattiFilter.vue?vue&type=template&id=a1e38d16&"
import script from "./CampagnaContattiFilter.vue?vue&type=script&lang=ts&"
export * from "./CampagnaContattiFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports